import { navigate } from "../../app/router.js";
import { useTenant } from "../../app/tenant.js";
import { Button, Icon, PageHead } from "../../ui/index.js";
import { ActionRow, orderedActions } from "./ActionRow.js";

export function ActionsScreen() {
  const { actions } = useTenant();
  return (
    <>
      <PageHead
        title="Actions"
        aside={
          <Button variant="primary" onClick={() => { navigate("/actions/new"); }}>
            <Icon name="plus" size={15} /> New action
          </Button>
        }
      />
      <ul className="action-list">
        {orderedActions(actions).map((action) => (
          <ActionRow key={action.id} action={action} open={{ kind: "page" }} />
        ))}
      </ul>
    </>
  );
}
